import { Button, Form, Input, Radio, Spin, Typography, Upload, message } from 'antd';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { cloneDeep, omit, uniq, uniqBy } from 'lodash';
import { commonPresenter, commonStore, documentArchivePresenter, documentArchiveStore } from 'stores/root_store';
import { getPlantCode, getUserSession } from 'utils/localStorageHelper';
import { useEffect, useRef, useState } from 'react';

import { BASE_API_URL } from 'utils/constants';
import BoxContainer from 'base/ui/components/BoxContainer';
import { CommonModel } from 'services/Main/common_services';
import CustomButton from "base/ui/components/Button";
import CustomInputString from 'base/ui/components/Input/customInputString';
import CustomSelect from 'base/ui/components/CustomSelect';
import { Download } from 'base/ui/components/Icons';
import { FileModel } from 'services/Main/documentArchive';
import PageWrapper from 'pages/Components/PageWrapper';
import { ROUTES } from 'base/routes/routes';
import { RcFile } from 'antd/es/upload';
import { UploadOutlined } from '@ant-design/icons';
import { User } from 'services/User/user_services';
import { checkPermission } from 'utils/permissionHelper';
import { downloadZip } from "client-zip";
import { getDropdownCatalog } from 'pages/Common/dropdown';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

// const getBase64 = (file: RcFile): Promise<string> =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result as string);
//     reader.onerror = (error) => reject(error);
//   });


function formatDateTimeFromFilename(filename: string) {
  // Regular expression to match the date-time part
  const regex = /(\d{4})-(\d{2})-(\d{2})T(\d{2})-(\d{2})-(\d{2})/;

  // Extract the date-time part from the filename
  const match = filename.match(regex);

  if (match) {
    // Destructure the matched groups
    const [, year, month, day, hour, minute] = match;

    // Format the date-time part to "DD-MM-YYYY hh:mm"
    const formattedDateTime = `${day}-${month}-${year} ${hour}:${minute}`;

    // Replace the date-time part in the filename with the formatted date-time
    const newFilename = filename.replace(regex, formattedDateTime);

    return newFilename;
  } else {
    // Return the original filename if no date-time part is found
    return filename;
  }
}


type Props = {
  onMoveTab?: (targetKey: string) => void,
  tabID?: string,
  archivesId?: string
}

const CreateUpdatePage = ({ onMoveTab, archivesId, tabID }: Props) => {
  const { t } = useTranslation();

  const dialogRef = useRef()

  const [form] = Form.useForm();



  const navigate = useNavigate();
  // ====== ================================================================================================
  const normFile = (e: any) => {
    // console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  }

  const [continousSave, setContinousSave] = useState(false)

  const [fileUrlRemove, setfileUrlRemove] = useState<FileModel[]>([])
  const [documentType, setdocumentType] = useState<CommonModel[]>([])
  const [infoType, setinfoType] = useState<CommonModel[]>([])
  const [listProduct, setListProduct] = useState<CommonModel[]>([])
  const user = getUserSession() as User;
  const [fileSelected, setFileSelected] = useState<any>()

  const [loadingPage, setLoadingPage] = useState(false)

  // Phòng ban
  const [listDepartment, setListDepartment] = useState<CommonModel[]>([]);
  const [listPRD, setListPRD] = useState<CommonModel[]>([]);
  // Công ty
  const [listCompany, setListCompany] = useState<CommonModel[]>([]);
  // Công ty
  const getDataCompany = async () => {
    await commonPresenter.getListSaleOrg(commonStore);
    if (commonStore.commonRespone.isSuccess) {
      setListCompany(commonStore.commonRespone.data);
    }
  };
  // -------------------------------------------------------------------------------------------------  ----------------------------------------------------------------
  // Phòng ban
  const getDataDepartment = async (key?: string) => {
    const congty = form.getFieldValue('companyCode')
    await commonPresenter.getListDepartment(commonStore, key, congty || getPlantCode());
    if (commonStore.commonRespone.isSuccess) {
      setListDepartment(commonStore.commonRespone.data);
    }
  };
  const getSPLienQuan = async (key?: string) => {
    const congty = form.getFieldValue('companyCode')
    await commonPresenter.getCommonDataByKey(commonStore, 'AssociatedProducts', undefined, congty);
    if (commonStore.commonRespone.isSuccess) {
      if (commonStore.commonRespone.isSuccess) {
        setListPRD(commonStore.commonRespone.data);
      }
    }
  };

  useEffect(() => {
    // sản phẩm liên quan
    // getDropdownCatalog({ onSetDropdown: setListProduct, params: { catalogTypeCode: 'AssociatedProducts' } })
    // loại thông tin
    getDropdownCatalog({ onSetDropdown: setinfoType, params: { catalogTypeCode: 'InformationCategory' } })
    // loại tài liệu
    getDropdownCatalog({ onSetDropdown: setdocumentType, params: { catalogTypeCode: 'DocumentType' } })

    getDataDepartment();
    getSPLienQuan();

    getDataCompany();
  }, [])

  const wrapUnwrappedLinksInHtml = (text: string) => {
    if (!text) return text;
    /*
      Dear người đến sau
      Đừng cố hiểu logic của đoạn code này
      Hãy nghĩ đơn giản rằng nó wrap 1 url hợp lệ vào thẻ a
      Và nếu có đoạn url wrap sẵn thẻ a thì nó sẽ bỏ qua
    */

    /*
      Input: This is a paragraph. <a href="www.google.com">www.google.com</a>. facebook.com</div>
      Output: This is a paragraph. <a href="www.google.com">www.google.com</a>. <a href="https://facebook.com">facebook.com</a></div>
    */
    const linkRegex = /<a\s+href="[^"]*">[^<]*<\/a>/g;
    const urlRegex = /(?<!<\/a>)\b(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.[a-zA-Z]{2,})(?!<\/a>)/g;

    let result = text;
    const extractedLinks: string[] = [];

    result = result.replace(linkRegex, match => {
      extractedLinks.push(match);
      return `<!--LINK${extractedLinks.length - 1}-->`;
    });

    result = result.replace(urlRegex, url => {
      const href = url.startsWith('http') ? url : `https://${url}`;
      return `<a href="${href}">${url}</a>`;
    });

    result = result.trim();
    result = result.replace(/\n/g, '<br>');

    extractedLinks.forEach((link, index) => {
      result = result.replace(`<!--LINK${index}-->`, link);
    });

    return result;
  };


  // ================================ CHI TIẾT VÀ UPDATE KHO TÀI LIỆU ================================================================
  const getDetail = async (id: string) => {
    await documentArchivePresenter.getDetail(documentArchiveStore, id);
    if (documentArchiveStore.detail.isSuccess) {
      form.setFieldsValue({
        documentName: documentArchiveStore.detail.data?.documentName,
        documentType: documentArchiveStore.detail.data?.documentType,
        productRef: documentArchiveStore.detail.data?.productRef,
        description: documentArchiveStore.detail.data?.description,
        infoType: documentArchiveStore.detail.data?.infoType,
        actived: documentArchiveStore.detail.data?.actived,
        departmentId: documentArchiveStore.detail.data?.departmentId,
        companyCode: documentArchiveStore.detail.data?.companyCode,
        fileUrl: documentArchiveStore.detail.data?.fileUrl?.length ?
          documentArchiveStore.detail.data?.fileUrl.map((item, index) => {
            return {
              uid: item.id,
              // name: `${item.name} - ${dayjs(item.createTime).format('DD/MM/YYYY')}`,
              name: `${formatDateTimeFromFilename(item.name)}`,
              url: item.url,
              status: 'done',
              originFileObj: item.url,
            }
          })
          : undefined
      })
    }
  }

  useEffect(() => {
    if (archivesId)
      getDetail(archivesId)
  }, [archivesId])

  const initialValues = { actived: true, companyCode: '1000' }


  const handleFinished = async (values: any) => {

    // tạo 1 mảng file để thêm hoặc cập nhật tài liệu
    const clone = values?.fileUrl?.map(async (item: any) => {
      if (!item.url?.startsWith('http')) {
        return {
          id: '00000000-0000-0000-0000-000000000000',
          name: item?.originFileObj.name,
          status: 'done',
          // url: await getBase64(item?.originFileObj as RcFile)
          url: await item?.originFileObj
        }
      } else {
        return {
          id: item?.uid,
          name: item?.originFileObj.name,
          status: 'done',
          url: item?.originFileObj
        }
      }
    })
    let temptData = omit(values, ['fileUrl'])


    // Upload file
    let cloneFiles: any = []
    if (values?.fileUrl) {
      cloneFiles = await Promise.all(clone)
    }
    const formData = new FormData();

    // kiểm tra nếu là file có đuôi là msg thì phải zip lại rồi mới append vào formdata để lưu bởi vì trình duyệt không hỗ trợ file msg
    const newArr = await cloneFiles.map(async (item: any, index: number) => {
      const name = cloneDeep(item.name)
      const checkName = name?.split('.').pop()
      const nameNoHasType = name?.split('.').shift()
      if (checkName === 'msg') {
        const blob = await downloadZip([item?.url]).blob()
        const newFile = new File([blob], `${nameNoHasType}.zip`)
        return {
          ...item,
          url: newFile
        }
      } else {
        return item
      }
    });

    const newPromise = await Promise.all(newArr)
    newPromise.forEach(async (item: any, index: number) => {
      formData.append(`FileUrlAdd`, item?.url)
    });

    // CHECK CÓ ID THÌ CALL API UPDATE CÒN KHÔNG THÌ THÊM MỚI
    if (archivesId) {
      const { fileUrl, ...rest } = temptData;
      // edit kho tài liệu
      const data = {
        ...rest,
        status: 'done',
        fileUrlDelete: fileUrlRemove,
        id: archivesId
      };
      await documentArchivePresenter.editDocumentArchive(documentArchiveStore, data)
      formData.append('DocumentId', archivesId);
      await documentArchivePresenter.uploadCreateDocumentArchive(documentArchiveStore, formData)

    } else {
      // CREATE KHO TÀI LIỆU
      await documentArchivePresenter.createDocumentArchive(documentArchiveStore, temptData)
      if (documentArchiveStore.createNew.isSuccess) {
        formData.append('DocumentId', documentArchiveStore.createNew.data);
        await documentArchivePresenter.uploadCreateDocumentArchive(documentArchiveStore, formData)
      }
    }

    if (documentArchiveStore.createUpdate.isSuccess) {
      message.success(documentArchiveStore.createUpdate.message)
      // kiểm tra xem có phải là lưu và cập nhật không
      if (continousSave) {
        setContinousSave(false)
        // Nếu là màn thêm mới dùng nút lưu và tiếp tục thì reset field
        if (!archivesId) {
          form.resetFields()
          form.setFieldsValue({ companyCode: '1000', actived: true })
        }
      } else {
        navigate(ROUTES.UTILITIES.ARCHIVES.LINK)
        window.location.reload()
      }
    }
  }



  return (
    <PageWrapper
      breadcrumb={[
        {
          text: 'Kho tài liệu',
          to: ROUTES.UTILITIES.ARCHIVES.BASE,
        },
        {
          text: archivesId ? 'Chi tiết' : "Thêm mới",
        },
      ]}
      extras={
        <>
          {checkPermission('EDIT') &&
            <>
              <CustomButton
                onClick={() => {
                  setContinousSave(false)
                  form.submit();
                }}
                type="default"
                loading={loadingPage}
                icon={<Download className="!fill-black" />}
              >
                {t("btn.save")}
              </CustomButton>
              <CustomButton
                onClick={() => {
                  form.submit();
                  setContinousSave(true)
                }}
                type="primary"
                loading={loadingPage}
                icon={<Download className="!fill-white" />}
              >
                Lưu và tiếp tục
              </CustomButton>
            </>
          }
        </>
      }
    >
      <Spin spinning={loadingPage} size="large">
        <BoxContainer fullHeight>
          <SearchForm form={form}
            initialValues={!archivesId ? initialValues : {}}
            onFinish={async (values) => {
              setLoadingPage(true)
              await handleFinished(values)
              setLoadingPage(false)
            }}>
            {/* TRÁI */}
            <div className="flex flex-col gap-1">
              {/* Tên tài liệu  */}
              <SearchItem
                name={"documentName"}
                rules={[{ required: true, message: 'Hãy nhập thông tin' }]}
                label={'Tên tài liệu'}
              >
                <CustomInputString />
              </SearchItem>
              {/* Loại tài liệu  */}
              <SearchItem
                name={"documentType"}
                label={'Loại tài liệu'}
              >
                <CustomSelect
                  fieldNames={{
                    value: 'key',
                    label: 'value'
                  }}
                  filterOption={(input, option) =>
                    (option?.value ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={documentType} allowClear showSearch />
              </SearchItem>
            </div>
            {/* PHẢI */}
            <div className="">
              {/* Sản phẩm liên quan  */}
              <SearchItem
                name={"productRef"}
                label={'Sản phẩm liên quan'}
              >
                <CustomSelect
                  options={listPRD}
                  fieldNames={{
                    value: 'key',
                    label: 'value'
                  }}
                  filterOption={(input, option) =>
                    (option?.value ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  allowClear showSearch />
              </SearchItem>
              {/* Loại thông tin  */}
              <SearchItem
                name={"infoType"}
                label={'Loại thông tin'}
              >
                <CustomSelect
                  fieldNames={{
                    value: 'key',
                    label: 'value'
                  }}
                  filterOption={(input, option) =>
                    (option?.value ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={infoType} allowClear showSearch />
              </SearchItem>

            </div>
            {/* Phòng ban */}
            <SearchItem
              name={"departmentId"}
              label="Phòng ban"
            >
              <CustomSelect
                options={listDepartment}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
                showSearch
              />
            </SearchItem>
            {/* Công ty */}
            <SearchItem
              name={"companyCode"}
              label={"Công ty"}
            >
              <CustomSelect
                allowClear
                options={listCompany}
                fieldNames={{ label: "value", value: "key" }}
                showSearch
                onChange={(value, option) => {
                  if (value) {
                    getDataDepartment()
                    // sản phẩm liên quan
                    getSPLienQuan()

                    form.resetFields(['departmentId', 'productRef'])
                  } else {
                  }
                }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </SearchItem>

            {/* Mô tả */}
            <SearchItem
              name={"description"}
              label={t("unidentified.mo-ta")}
              col2
            >
              <Input.TextArea rows={4} />
            </SearchItem>
            <SearchItem
              name={"description1"}>
              <>{wrapUnwrappedLinksInHtml(form.getFieldValue('description'))}</>
            </SearchItem>
            {/* đính kèm */}
            <SearchItem label="Đính kèm" name="fileUrl"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              noStyle
            >
              <Upload
                multiple
                // accept="image/jpeg,image/png,application/pdf"
                showUploadList={
                  {
                    showDownloadIcon: true,
                    downloadIcon(file) {
                      return <Text copyable={{ text: file.url }}></Text>
                    },
                  }
                }

                ref={dialogRef}

                onChange={({ file, fileList }) => {
                  const uniqByFileList = uniqBy(fileList, 'name')
                  uniqByFileList.map(async (download) => {
                    if (download.name.split('.').pop() === 'msg') {
                    } else {
                      return download
                    }
                  })
                  form.setFieldValue('fileUrl', uniqByFileList)
                }}
                beforeUpload={(_file, fileList) => {
                  const temp1 = form.getFieldValue('fileUrl')
                  const temp2 = cloneDeep(fileList)
                  const formFileList = [...temp1, ...temp2]
                  const uniqByFileList = uniqBy(formFileList, 'name')
                  if (uniqByFileList.length < formFileList.length) {
                    message.warning("Chọn file bị trùng")
                  }
                  return true
                }}

                // }}
                // làm giả progress bar trong upload
                customRequest={(options) => {
                  const { onSuccess } = options;
                  setTimeout(() => {
                    onSuccess && onSuccess("Ok");
                  }, 1000)
                }}

                progress={{
                  strokeColor: {
                    '0%': '#108ee9',
                    '100%': '#87d068',
                  },
                  // size: 3,
                  format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`
                }}
                onPreview={async (file) => {
                  const fileExtension = file.name.split('.').pop() || ''
                  const listImageOrPDF = ['jpeg', 'png', 'gif', 'pdf', 'jpg']
                  if (listImageOrPDF.includes(fileExtension)) {
                    window.open(file.url)
                  } else {
                    window.open(`${BASE_API_URL}/Extensions/download-file?fileUrl=${file.url}&fileName=${file.name}`)
                  }
                }}
                onRemove={(file) => {
                  let arr = [...fileUrlRemove]
                  const check = documentArchiveStore.detail.data?.fileUrl?.find((item) => {
                    return item.id === file.uid
                  })
                  if (check) {
                    arr.push(check)
                    setfileUrlRemove(arr)
                  }
                }}
              >
                <Button icon={<UploadOutlined />}>Nhấn để tải lên</Button>
              </Upload>
            </SearchItem>
            {/* trạng thái */}
            <SearchItem name={'actived'} label={t('segment.trang-thai')}>
              <Radio.Group>
                <Radio value={true}>Đang sử dụng</Radio>
                <Radio value={false}>Ngưng sử dụng</Radio>
              </Radio.Group>
            </SearchItem>
          </SearchForm>
        </BoxContainer>
      </Spin>

    </PageWrapper >
  )
}

export default observer(CreateUpdatePage)